import { useEffect, useState } from 'react';

// Exporting so we can test this function
/**
 * Merges two objects, but also removes/adds fields based on defaultObj
 * fields and structure
 * @param {Object} defaultObj Object with default fields
 * @param {Object} savedObj Object Saved object
 */
export function mergeData(defaultObj, savedObj) {
  const merged = {};

  Object.keys(defaultObj).forEach((k) => {
    if (!Object.prototype.hasOwnProperty.call(savedObj, k)) {
      merged[k] = defaultObj[k];
    }
  });
  Object.keys(savedObj).forEach((k) => {
    if (Object.prototype.hasOwnProperty.call(defaultObj, k)) {
      merged[k] = savedObj[k];
    }
  });

  return merged;
}

export function useLocalStorage(
  key,
  defaultValue = '',
  options = { merge: false }
) {
  const [state, setState] = useState(() => {
    try {
      const value = window.localStorage.getItem(key);

      if (value) {
        const saved = JSON.parse(value);

        if (options.merge) {
          return mergeData(defaultValue, saved);
        }

        return saved;
      }
      return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(state));
    } catch (e) {
      // Noop
    }
  }, [key, state]);

  return [state, setState];
}

export default useLocalStorage;
